module.exports = __webpack_public_path__ + "img/1.20210923SCAD_Mobile_02.61e20e99.jpg";